export const authPageContent = {
  tabs: {
    register: "Register",
    login: "Log in",
  },
  pages: {
    login: {
      title: "Continue profiling",
      description: "Return to your career thoughts and situations.",
      alternate: {
        prompt: "New here?",
        pathname: "/register",
        linkLabel: "Create an account",
      },
    },
    register: {
      title: "Profile Yourself",
      description: "Turn real experience into a maintained career profile.",
      alternate: {
        prompt: "Already have an account?",
        pathname: "/login",
        linkLabel: "Sign in",
      },
    },
  },
  forms: {
    loadingText: "Loading...",
    login: {
      submitLabel: "Sign in",
    },
    register: {
      submitLabel: "Create account",
    },
  },
} as const;

export type AuthSubmitLabel =
  | typeof authPageContent.forms.login.submitLabel
  | typeof authPageContent.forms.register.submitLabel;
